
import { ProductDescription } from "@/lib/api";
import { supabase } from "@/integrations/supabase/client";

export interface EditResult {
  success: boolean;
  updatedCount: number;
  error?: string;
}

export const productEditService = {
  async editProduct(
    product: ProductDescription,
    newDescription: string,
    newOriginalText: string,
    newProductDetails?: string
  ): Promise<EditResult> {
    try {
      console.log("[ProductEditService] Starting edit:", {
        productId: product.id,
        hasContentId: !!product.content_id,
        contentId: product.content_id,
        hasProductDetails: !!newProductDetails
      });

      // Prepare update data
      const updateData: any = {
        improved_description: newDescription,
        original_text: newOriginalText,
        status: "pending", // Reset status after edit
        updated_at: new Date().toISOString()
      };

      // Only include product_details if it's provided
      if (newProductDetails !== undefined) {
        updateData.product_details = newProductDetails;
      }

      // Update the product - the database trigger will handle group synchronization
      const { error, data } = await supabase
        .from("product_descriptions")
        .update(updateData)
        .eq("id", product.id)
        .select();

      if (error) {
        console.error("[ProductEditService] Update error:", error);
        throw error;
      }

      // Count how many products were affected (for group products)
      let updatedCount = 1;
      if (product.content_id) {
        const { data: groupData, error: countError } = await supabase
          .from("product_descriptions")
          .select("id", { count: 'exact' })
          .eq("content_id", product.content_id)
          .eq("collection_id", product.collection_id);
        
        if (!countError && groupData) {
          updatedCount = groupData.length;
        }
      }

      console.log("[ProductEditService] Edit successful:", {
        productId: product.id,
        updatedCount
      });

      return {
        success: true,
        updatedCount
      };
    } catch (error: any) {
      console.error("[ProductEditService] Edit failed:", error);
      return {
        success: false,
        updatedCount: 0,
        error: error.message || "Failed to update product"
      };
    }
  }
};
